import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { ConfigService } from './auth/config.service';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
 
@Injectable({
  providedIn: 'root'
})
export class CommonService {
    constructor(private http: HttpClient,
        private configService: ConfigService){}
        GetMasterData(action:any, Id:number) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=${action}&Id=${Id}`;
        return this.http.get<any>(apiUrl).pipe(
          map((response) => {
            return response;
          }),
          catchError((err) => {
            return throwError(() => new Error('Master data retrieval failed.'));
          })
        );
      }  
      getCooperativeSocieties(selectedSocietyType:any) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/GetCooperativeSocieties?societyTypeId=${selectedSocietyType}`;
        return this.http.get<any>(apiUrl).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Society details retrieval failed.'));
          })
        )
      }
      CheckDuplicateEmailOrMobile(emailId:string, mobile:string) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/CheckDuplicateEmailOrMobile?emailId=${emailId}&mobile=${mobile}`;
        return this.http.get<any>(apiUrl).pipe(
          map((response) => {
            return response;
          }),
          catchError((err) => {
            return throwError(() => new Error('Data retrieval failed.'));
          })
        );
      }  
      SMS_Setting(societyID:string, mobile:string, SMSTemplateID:string){
        const apiUrl = `${this.configService.getApiUrl()}/Common/SMS_Setting?societyID=${societyID}&mobile=${mobile}&SMSTemplateID=${SMSTemplateID}`;
        return this.http.get<any>(apiUrl).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Data retrieval failed.'))
          })
        );
      }
      updateUser(payload:any){
        const apiUrl = `${this.configService.getApiUrl()}/Common/CreateUser`;
        return this.http.post<any>(apiUrl,payload).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Data retrieval failed.'))
          })
        );
      }
      deactiveUser(payload:any){
        const apiUrl = `${this.configService.getApiUrl()}/Common/DeActiveUser`;
        return this.http.post<any>(apiUrl,payload).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Data retrieval failed.'))
          })
        );
      }
     

       getApplicationUserList(action: string) {
  const apiUrl = `${this.configService.getApiUrl()}/Common/GetApplicationUserList?action=${action}`;
  return this.http.get<any>(apiUrl).pipe(
    map((response) => response),
    catchError((err) => {
      console.error('API Error: ', err);
      return throwError(() => new Error('Data retrieval failed.'));
    })
  );
}
     deActiveUser(iUserId: any, action: string) {
  const apiUrl = `${this.configService.getApiUrl()}/Common/DeActiveUser?iUserId=${iUserId}&action=${action}`;

  return this.http.post<any>(apiUrl, {}).pipe(
    map((response) => response),
    catchError((err) => throwError(() => new Error('Data retrieval failed.')))
  );
}

      GetTables(flag:number) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/GetTables?flag=${flag}`;
        return this.http.get<any>(apiUrl).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Details retrieval failed.'));
          })
        )
      }
      GetTableData(flag:number, tableId:Number, tblName:string) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/GetTableData?flag=${flag}&Id=${tableId}&tblName=${tblName}`;
        return this.http.get<any>(apiUrl).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Details retrieval failed.'));
          })
        )
      }
      UpdateMasterTableData(Id:number, IdColumn:string,IdValue:number, jsonData:any) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/UpdateMasterTableData`;
        const body = { Id, IdColumn,IdValue, jsonData };
        
        return this.http.post<any>(apiUrl,body).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Details retrieval failed.'));
          })
        )
      }
      InsertMasterTableDetails(body:any) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/InsertMasterTableDetails`;
        
        return this.http.post<any>(apiUrl,body).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Details retrieval failed.'));
          })
        )
      }
      AddMasterTableData(Id:number, IdColumn:string,IdValue:number, jsonData:any) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/AddMasterTableData`;
       const body = { Id, IdColumn,IdValue, jsonData };
        return this.http.post<any>(apiUrl,body).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Details retrieval failed.'));
          })
        )
      }
      AddHoliday(body:any) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/AddHoliday`;
        
        return this.http.post<any>(apiUrl,body).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Details retrieval failed.'));
          })
        )
      }
       getEvents(flag:number, Id:number, PageSize:number,PageNumber:number) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/getEvents?flag=${flag}&Id=${Id}&PageSize=${PageSize}&PageNumber=${PageNumber}`;
        return this.http.get<any>(apiUrl).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Details retrieval failed.'));
          })
        )
      }


  incrementVisit() {
  const apiUrl = `${this.configService.getApiUrl()}/Common/increment`;
  return this.http.post<{ visitCount: number }>(apiUrl, {}).pipe(    
    map(response => response),
    catchError(err => {
      return throwError(() => new Error('Visit increment failed.'));
    })
  );
}

getVisitCount() {
  const apiUrl = `${this.configService.getApiUrl()}/Common/get`;
  return this.http.get<{ visitCount: number }>(apiUrl).pipe(
    map(response => response),
    catchError(err => {
      return throwError(() => new Error('Visit count retrieval failed.'));
    })
  );
}
GetAuthorityList() {
  const apiUrl = `${this.configService.getApiUrl()}/Common/GetAuthorityList`;

  return this.http.get<any>(apiUrl).pipe(
    map((response)=>{
      return response;
    }),
    catchError((err)=>{
      return throwError(()=> new Error('Details retrieval failed.'));
    })
  )
}
  getCaseStages(): Observable<any[]> {
    return this.http.get<any[]>(`${this.configService.getApiUrl()}/Legal/BindCaseStages`);
  }


  //   incrementVisit() {
  //   return this.http.post<{ visitCount: number }>('https://yourdomain/api/sitevisit/increment', {});
  // }

  // getVisitCount() {
  //   return this.http.get<{ visitCount: number }>('https://yourdomain/api/sitevisit/get');
  // }

  addFeedback(data:any) {
        const apiUrl = `${this.configService.getApiUrl()}/Common/AddFeedback`;
        
        return this.http.post<any>(apiUrl,data).pipe(
          map((response)=>{
            return response;
          }),
          catchError((err)=>{
            return throwError(()=> new Error('Details retrieval failed.'));
          })
        )
      }
  changeUserPassword(data:any)
  {
    const apiUrl = `${this.configService.getApiUrl()}/User/changeUserPassword`;
    return this.http.post<any>(apiUrl,data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Sorry! Not Update Information.'));
      })
    );
  }
}